if (window.__cmp) {
	import('./consentmanager.js');
} else if (window.OneTrust || window.OnetrustActiveGroups) {
	import('../onetrust/onetrust.js');
}
